import React from 'react'
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import * as styles from './ArticleCTA.module.css'

export type ArticleCTAProps = {
  title: string
  description: string
  action_button: CustomLinkTypes[]
}

export function ArticleCTA({ title = '', description = '', action_button = [] }: ArticleCTAProps) {
  return (
    <section className="border-grey-100 border-t-1 border-b-1 text-center my-32 py-48 netbook:py-80">
      <h2 className="text-headingM text-text-dark-900 font-bold mb-24">{title}</h2>
      <p className="text-bodyM text-text-dark-900 w-3/4 m-auto">{description}</p>
      <div className={styles.btnWrapper}>
        {action_button?.map((item) => (
          <span key={item._uid}>
            <CustomLink {...item}>{item.text}</CustomLink>
          </span>
        ))}
      </div>
    </section>
  )
}
